/* eslint-disable class-methods-use-this */
import React from 'react';
import { Button } from 'rsuite';
import {
  ChartSelectionModal,
  connectTranslations,
} from './chart-selection-modal';

@connectTranslations
export class AddChartModal extends ChartSelectionModal {
  StyledAddButton = () => (
    <Button onClick={() => this.handleAddSelected()} color="blue">
      Add
    </Button>
  );
}
